import { render, staticRenderFns } from "./PokedexModal.vue?vue&type=template&id=7e52e6fd&scoped=true"
import script from "./PokedexModal.vue?vue&type=script&lang=js"
export * from "./PokedexModal.vue?vue&type=script&lang=js"
import style0 from "./PokedexModal.vue?vue&type=style&index=0&id=7e52e6fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e52e6fd",
  null
  
)

export default component.exports